module.exports = __webpack_public_path__ + "static/media/dak-icons-about(2).d486af40.svg";